// @flow

import * as React from 'react';
import { Box, Heading } from 'grommet';
import { FormattedMessage, injectIntl } from 'react-intl';
import HorizontalLine from 'esm-web-pro/components/layout/HorizontalLine';
import NotificationTypeContentRow from 'esm-web-pro/containers/notifications/NotificationTypeContentRow';

type Props = {
    notification: Object,
}

const NotificationTypeContent = (props: Props) => {
    const {
        notification: {
            channels, scopes, notification_type_scopes: notificationTypeScopes,
            notification_type_channels: notificationTypeChannels,
        },
    } = props;

    return (
        <Box pad={{ vertical: '20px' }} background="#f3f4f5" height={{ min: '100%' }}>
            <Box pad={{ horizontal: '16px', bottom: 'xsmall' }}>
                <Heading size="14px" weight={600}>
                    <FormattedMessage
                        id="channels-content-title"
                        defaultMessage="Channels"
                    />
                </Heading>
            </Box>
            <HorizontalLine color="#D6D7DA" />
            <Box>
                {channels.map((channel) => {
                    const typeChannel = notificationTypeChannels.find((c) => c.channel.id === channel.id);
                    return (
                        <React.Fragment key={channel.id}>
                            <NotificationTypeContentRow
                                object={channel}
                                type="notification-channel"
                                text={channel.translations.bg.name}
                            />
                            <NotificationTypeContentRow
                                object={typeChannel}
                                type="notification-type-channel"
                                text={(
                                    <FormattedMessage
                                        defaultMessage="Channel data"
                                        id="notification-type-channel-data"
                                    />
                                )}
                                textPad={{ left: 'medium', right: 'small' }}
                            />
                        </React.Fragment>
                    );
                })}
            </Box>
            <Box pad={{ horizontal: '16px', bottom: 'xsmall', top: 'small' }}>
                <Heading size="14px" weight={600}>
                    <FormattedMessage
                        id="scopes-content-title"
                        defaultMessage="Scopes"
                    />
                </Heading>
            </Box>
            <HorizontalLine color="#D6D7DA" />
            <Box />
            <Box>
                {scopes.map((scope) => {
                    const typeScope = notificationTypeScopes.find((c) => c.scope.id === scope.id);
                    return (
                        <React.Fragment key={scope.id}>
                            <NotificationTypeContentRow
                                object={scope}
                                type="notification-scope"
                                text={scope.translations.bg.name}
                            />
                            <NotificationTypeContentRow
                                object={typeScope}
                                type="notification-type-scope"
                                text={(
                                    <FormattedMessage
                                        defaultMessage="Scope data"
                                        id="notification-type-scope-data"
                                    />
                                )}
                                textPad={{ left: 'medium', right: 'small' }}
                            />
                        </React.Fragment>
                    );
                })}
            </Box>
        </Box>
    );
};

export default injectIntl(NotificationTypeContent);
